import { render, staticRenderFns } from "./veJkyMeetShen.vue?vue&type=template&id=66d8311b&scoped=true"
import script from "./veJkyMeetShen.vue?vue&type=script&lang=js"
export * from "./veJkyMeetShen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d8311b",
  null
  
)

export default component.exports